import { px } from '../utils';
import breakpoints from './breakpoints';
function maxMobileMediaQuery() {
  return `screen and (max-width: ${px(breakpoints.mobileMax)})`;
}
function minDesktopMediaQuery() {
  return `screen and (min-width: ${px(breakpoints.desktopMin)})`;
}
function maxDesktopMediaQuery() {
  return `screen and (max-width: ${px(breakpoints.desktopMax)})`;
}
function customMediaQuery(value) {
  let feature = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'min-width';
  let mediaType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'screen';
  return `${mediaType} and (${feature}: ${value})`;
}
export { maxMobileMediaQuery, minDesktopMediaQuery, maxDesktopMediaQuery, customMediaQuery };